module.exports = __webpack_public_path__ + "static/media/Integration.670cf1d8.svg";